import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import FamilyEnrollmentSearcher from "../../components/FamilyEnrollmentSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class FamilyEnrollmentHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(`/enrollment/family/${enrollment.uuid}/detail`);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <FamilyEnrollmentSearcher
          cacheFiltersKey="enrollmentFamilyPageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(withTheme(withStyles(styles)(FamilyEnrollmentHomePage)))
  )
);
